import { render } from "./VideoDetailsCategory.vue?vue&type=template&id=62ce6a26&ts=true"
import script from "./VideoDetailsCategory.vue?vue&type=script&lang=ts"
export * from "./VideoDetailsCategory.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__